const UserTypes = Object.freeze({
  CUSTOMER: "customer",
  CLERK: "clerk",
});

export default UserTypes;
